import React, { Fragment, PureComponent } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

import MyZzimNew from "./MyZzimNew";
// import MyViewNew from "./MyViewNew";
import MyViewNew1 from "./MyViewNew1";
// import MyDownNew from "./MyDownNew";
import MyDownNew1 from "./MyDownNew1";
import { isMobile, isAndroid, isIOS } from "react-device-detect";

class MyBox extends PureComponent {
  state = {
    index: this.props.childProps.index ? this.props.childProps.index : 0,
  };
  componentDidMount = () => {};
  _changeIndex = (index) => {
    const { _myMenu } = this.props.childProps;
    _myMenu(index);
  };
  render() {
    const { index } = this.props.childProps;
    return (
      <Fragment>
        <div className="my_con">
          <div className="my_tab">
            {isMobile ? null : (
              <h3>
                <a href="#" class="btn_back"></a>내 보관함
              </h3>
            )}
            <ul>
              <li>
                <button
                  type="button"
                  className={index === 0 ? "active" : null}
                  onClick={() => this._changeIndex(0)}
                >
                  나의 찜한 작품
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className={index === 1 ? "active" : null}
                  onClick={() => this._changeIndex(1)}
                >
                  나의 관람 작품
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className={index === 11 ? "active" : null}
                  onClick={() => this._changeIndex(11)}
                >
                  다운받은 작품
                </button>
              </li>
            </ul>
          </div>

          {index === 0 ? (
            <MyZzimNew />
          ) : index === 1 ? (
            <MyViewNew1 />
          ) : index === 11 ? (
            <MyDownNew1 />
          ) : null}
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(MyBox)));
